import { useCallback, useState } from "react"

import { toast } from "@/components/toast"
import { api } from "@/lib/api"

export function useContactsExport() {
	const [isLoading, setIsLoading] = useState(false)

	const exportMutation = api.workspace.exportContacts.useMutation({
		onSuccess: (data) => {
			const blob = new Blob([data.csvData], { type: "text/csv;charset=utf-8;" })
			const link = document.createElement("a")
			const url = URL.createObjectURL(blob)
			link.setAttribute("href", url)
			link.setAttribute(
				"download",
				`contacts-export-${new Date().toISOString().split("T")[0]}.csv`,
			)
			link.style.visibility = "hidden"
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
			URL.revokeObjectURL(url)

			toast.success({
				title: "Contacts exported successfully",
				description: "Your contacts data has been downloaded as a CSV file.",
			})
		},
		onError: (error) => {
			toast.error({
				title: "Export failed",
				description:
					error.message || "Failed to export contacts. Please try again.",
			})
		},
	})

	const exportNow = useCallback(async () => {
		setIsLoading(true)
		try {
			await exportMutation.mutateAsync({})
		} finally {
			setIsLoading(false)
		}
	}, [exportMutation])

	return { exportNow, isLoading }
}
